import styled from 'styled-components';
import Icon from '../../assets/images/tick-green-circle-icon.svg';

interface TickGreenCircleIconProps {
  height?: number;
  width?: number;
}

const TickGreenCircleIcon = styled.span<TickGreenCircleIconProps>`
  ${({ height = 24, width = 24 }) => `
    background: url(\"${Icon}\") no-repeat left center;
    background-size: ${width}px ${height}px;
    display: block;
    position: relative;
    width: ${width}px;
    height: ${height}px;
  `}
`;

export default TickGreenCircleIcon;
